import React from "react";

export default function Footer() {
  return (
    <footer>
      <div className="footer-info footer-info--inverse">
        <p>
          <a className="footer-img" href="/about" rel="noopener noreferrer">
            <img className="sm-fav" src="/pics/hub.png" alt="Abut HUB" />
          </a>
        </p>
        <p className="footer-p">
          <a href="/about" rel="noopener noreferrer">
            About
            <br />
            HUB
          </a>
        </p>
      </div>

      <div className="footer-info">
        <p className="footer-p">
          <a
            href="https://smessina.com"
            rel="noopener noreferrer"
            target="_blank"
          >
            Sam Messina
            <br />© {new Date().getFullYear()}
          </a>
        </p>
        <p>
          <a
            className="footer-img"
            href="https://smessina.com"
            rel="noopener noreferrer"
            target="_blank"
          >
            <img
              className="sm-fav"
              src="https://smessina.com/sm"
              alt="smessina.com"
            />
          </a>
        </p>
      </div>
    </footer>
  );
}
